module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Spatula-9c497ba519127af97007eb4387656dfa.svg";